import { Button, Dialog } from "@digdir/designsystemet-react";
import { ResultTable } from "@/components/athlete-overview-page/athlete-dialog/result-table";
import { AthleteStats } from "@/components/athlete-overview-page/athlete-dialog/athlete-stats";
import { UseAthleteOverview } from "../athlete-overview-page-provider";


export function AthleteDialog() {
    const { data, updateSearchParams } = UseAthleteOverview()
    const { searchParams, selectedAthlete } = data
    if (!searchParams.fisCode) return null;
    const handleOnClose = () => updateSearchParams({ fisCode: null })

    return (
        <Dialog open={!!searchParams.fisCode} closedby={"any"} onClose={handleOnClose} closeButton={false}
            className="relative rounded-none w-full h-full overflow-y-auto sm:overflow-hidden !max-w-content bg-brand-detail-gray-light">
            <div className="fixed top-2 right-2 sm:hidden z-30">
                
                <Button
                    onClick={handleOnClose}
                    type="button"  
                    variant="tertiary"
                    className="bg-white text-neutral-text-default size-5 flex items-center justify-center rounded-full overflow-hidden ">
                    <span aria-hidden="true" className="material-symbols-rounded">
                        close
                    </span>
                </Button>
            </div>
            <div className=" w-full h-full flex flex-col sm:flex-row">
                <AthleteStats {...selectedAthlete!} />
                <ResultTable {...selectedAthlete!} />
            </div>
        </Dialog>
    )
}